import { Fragment, useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import { Btn } from "../../../AbstractElements";
import Dropzone from "react-dropzone-uploader";
import { useNavigate } from "react-router";
import { useDataFetch } from "../../Hooks/Use-data-fetch";
import { toast } from "react-toastify";
import { API_BASE_URL } from "../../api/api";
import { PageHeader } from "../../Components/common/PageHeader";

const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result.split(",")[1]);
    reader.onerror = (error) => reject(error);
  });

export const Banner = () => {
  const navigate = useNavigate();
  const { getData, postData, patchData, invalidateQuery } = useDataFetch();

  const [imageName, setImageName] = useState(null);
  const [isEnabled, setIsEnabled] = useState(true);


  const { data: bannerResponse, isLoading } = getData(
    ["banner"],
    "/product/get/banner"
  );

  useEffect(() => {
    if (bannerResponse?.banner) {
      setImageName(bannerResponse.banner.image || null);
      setIsEnabled(bannerResponse.banner.status);
    }
  }, [bannerResponse]);


  const { mutateAsync: saveBanner, isPending: saving } = postData(
    "/product/banner",
    {},
    {
      onSuccess: (response) => {
        if (response.message === "banner_save_or_update_success") {
          toast.success("Configuración guardada correctamente");
          invalidateQuery(["banner"]);
        } else {
          toast.error("Error al guardar configuración");
        }
      },
      onError: (error) => {
        toast.error(error.message);
      },
    }
  );


  const { mutateAsync: toggleBanner } = patchData(
    "/product/banner/toggle-status",
    {},
    {
      onSuccess: (response) => {
        if (response?.banner) {
          setIsEnabled(response.banner.status);
          toast.success("Estado actualizado");
          invalidateQuery(["banner"]);
        }
      },
      onError: (error) => {
        toast.error(error.message);
      },
    }
  );



  const { mutateAsync: uploadBanner } = postData(
    "/product/upload-file-banner",
    {},
    {
      onSuccess: (response) => {
        if (response.message === "file_create_success") {
          setImageName(response.data.fileName);
          toast.success("Imagen subida correctamente");
        } else {
          toast.error("Error al subir imagen");
        }
      },
      onError: (error) => {
        toast.error(error.message);
      },
    }
  );

  const handleChangeStatus = async (fileWithMeta, status) => {
    const file = fileWithMeta.file;

    if (status === "done") {
      try {
        const base64URL = await fileToBase64(file);

        await uploadBanner({
          file: {
            name: file.name,
            base64URL,
          },
        });
      } catch (error) {
        toast.error("Error procesando archivo");
      }
    }

    if (status === "removed") {
      setImageName(null);
    }
  };


  const handleSave = async (e) => {
    e.preventDefault();

    if (!imageName && isEnabled) {
      toast.warning("Debes subir una imagen si el banner está habilitado");
      return;
    }

    await saveBanner({
      image: imageName,
      status: isEnabled,
    });
  };

  const previewUrl = imageName
    ? `${API_BASE_URL}/product/get-file-banner/${imageName}`
    : null;

  return (
    <Fragment>
      <PageHeader title="Banners" crumbs={[{ label: "Productos" }, { label: "Banners" }]} />

      {isLoading ? (
        <div className="ui-card text-center" style={{ color: "#5A6187" }}>Cargando configuración...</div>
      ) : (
        <form onSubmit={handleSave}>
          <div className="ui-card">
            <Row className="mb-4">
              <Col md="6">
                <h3 style={{ fontSize: 16, fontWeight: 700, margin: 0 }}>Configuración del banner</h3>
              </Col>

              <Col
                md="6"
                className="d-flex align-items-center justify-content-md-end mt-3 mt-md-0"
              >
                <div className="d-flex align-items-center justify-content-end gap-3">
                  <span style={{ fontWeight: 600, fontSize: 13, color: isEnabled ? "#0F9A5A" : "#8A91AE" }}>
                    {isEnabled ? "Banner activo" : "Banner inactivo"}
                  </span>

                  <div
                    onClick={() => toggleBanner({})}
                    role="switch"
                    aria-checked={isEnabled}
                    style={{
                      width: 38,
                      height: 22,
                      borderRadius: 99,
                      backgroundColor: isEnabled ? "#0F9A5A" : "#D5D9E8",
                      cursor: "pointer",
                      position: "relative",
                      transition: "all ease .2s",
                      flexShrink: 0,
                    }}
                  >
                    <div
                      style={{
                        width: 18,
                        height: 18,
                        borderRadius: "50%",
                        backgroundColor: "#fff",
                        position: "absolute",
                        top: 2,
                        left: isEnabled ? 18 : 2,
                        transition: "all ease .2s",
                        boxShadow: "0 1px 2px rgba(14,21,51,.2)",
                      }}
                    />
                  </div>
                </div>
              </Col>
            </Row>

            <hr />

            {/* Vista previa */}
            <div className="mb-4">
              <h4 style={{ fontSize: 13, fontWeight: 700, marginBottom: 12 }}>Imagen actual</h4>

              <div
                style={{
                  width: "100%",
                  minHeight: 300,
                  borderRadius: 11,
                  backgroundColor: "#FAFAFF",
                  border: "1.5px dashed #C3C8DC",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                {previewUrl ? (
                  <img
                    src={previewUrl}
                    alt="Banner Preview"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                  />
                ) : (
                  <span style={{ color: "#8A91AE" }}>No hay imagen cargada</span>
                )}
              </div>
            </div>

            {/* Dropzone */}
            <div>
              <h4 style={{ fontSize: 13, fontWeight: 700, marginBottom: 12 }}>Subir / reemplazar imagen</h4>

              <Dropzone
                onChangeStatus={handleChangeStatus}
                accept="image/*"
                maxFiles={1}
                multiple={false}
                canCancel={false}
                inputContent="Arrastra o haz clic para subir la imagen"
              />
            </div>
          </div>

          <div className="d-flex justify-content-end gap-2 my-4">
            <Btn
              attrBtn={{
                color: "secondary",
                type: "button",
                onClick: () => navigate(-1),
              }}
            >
              <i className="ri-arrow-left-line me-2"></i> Volver
            </Btn>

            <Btn
              attrBtn={{
                color: "primary",
                type: "submit",
                disabled: saving,
              }}
            >
              <i className="ri-save-line me-2"></i>
              {saving ? "Guardando..." : "Guardar configuración"}
            </Btn>
          </div>
        </form>
      )}
    </Fragment>
  );
};